import React, { Component } from 'react'

class Post extends Component {
  render() {
    return <div>Good to see you!</div>
  }
}

export default Post
